/**
 * Unified collision detection framework.
 * Pure computation — no Firebase calls.
 *
 * Usage:
 *   const { checkPlacement } = require('./collision');
 *   const result = checkPlacement(object, roomData);
 *   if (!result.valid) console.log(result.collisions);
 */

const { checkPlacement } = require('./checkPlacement');
const {
  getClearanceConfig,
  isExpectedOverlap,
  CLEARANCE_CONFIG,
} = require('./clearanceConfig');
const {
  checkFixtureCollisions,
  checkIntraGroupAccessoryCollisions,
} = require('./fixtureCollision');
const {
  checkDoorSwingCollisions,
  calculateDoorZone,
  computeOpenLeaf,
  doorSwingsIntoRoom,
  openLeafFootprint,
} = require('./doorCollision');
const { chooseHingeSide } = require('./doorHinge');
const {
  checkWallMountedCollisions,
  checkParentWallBounds,
} = require('./wallCollision');
const { checkClearanceBoundary } = require('./clearanceBoundary');
const { snapToValidPosition } = require('./snapToValid');
const { EXACT, FLOORPLAN, FP_EPSILON } = require('./tolerances');
const {
  computeDirectionalMTV,
  calculateMTV,
  sweptDistance,
  overlapAmount,
} = require('../bathroom-analyzer/pipeline/5.1-physicalCollisions');
const { wallToObb } = require('../bathroom-analyzer/pipeline/geometry');

module.exports = {
  // Main API
  checkPlacement,
  snapToValidPosition,

  // Individual checks (for callers that need granular control)
  checkFixtureCollisions,
  checkIntraGroupAccessoryCollisions,
  checkDoorSwingCollisions,
  checkWallMountedCollisions,
  checkParentWallBounds,
  checkClearanceBoundary,

  // Configuration
  getClearanceConfig,
  isExpectedOverlap,
  CLEARANCE_CONFIG,

  // Utilities
  calculateDoorZone,
  computeOpenLeaf,
  doorSwingsIntoRoom,
  openLeafFootprint,
  chooseHingeSide,

  // Unified collision primitives
  computeDirectionalMTV,
  calculateMTV,
  sweptDistance,
  overlapAmount,
  wallToObb,

  // Tolerance regimes
  EXACT,
  FLOORPLAN,
  FP_EPSILON,
};
